import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { UserDto } from "../../../Component/Model/Dto/User";
import { DateFormatter } from "../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";

interface UserRow {
    ID: string,
    Username: string,
    Email: string,
    Name: string,
    TelephoneNumber: string,
    LastLogInDate: string,
    UserType: string,
    CreatedByName: string,
    Actions: ActionType[]
}

interface UserManagementTable {
    columns: Array<TableColumn>;
    rows: Array<UserRow>;
}

export function MapToUserManagementTable(dataObject: UserDto.UserRowData[], handleEdit: (id: string) => void, handleRoles: (id: string) => void, handleDelete: (id: string) => void): UserManagementTable {
    const columns = [
        { Header: 'Name', accessor: 'Name', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Username', accessor: 'Username', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Email', accessor: 'Email', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Telephone Number', accessor: 'TelephoneNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'User Type', accessor: 'UserType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Last Log In Date', accessor: 'LastLogInDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created By', accessor: 'CreatedByName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} /> },
    ];

    if (dataObject !== undefined && dataObject.length > 0) {
        const rows: UserRow[] = dataObject.map((item: UserDto.UserRowData) => ({
            ID: item.id,
            CreatedByName: item.createdByName,
            Email: item.email,
            LastLogInDate: item.lastLogInDate ? DateFormatter(item.lastLogInDate.toString()) : '',
            Name: item.name,
            TelephoneNumber: item.telephoneNumber,
            UserType: item.userType,
            Username: item.username,
            Actions: [
                {
                    label: 'View/Edit',
                    action: () => { handleEdit(item.id) },
                    key: item.id,
                    icon: { color: 'info', name: 'edit' }
                },
                {
                    label: 'User Roles',
                    action: () => { handleRoles(item.id) },
                    key: item.id,
                    icon: { color: 'info', name: 'person' }
                },
                {
                    label: 'Delete',
                    action: () => { handleDelete(item.id) },
                    key: item.id,
                    icon: { color: 'error', name: 'delete' }
                }
            ]
        }));

        return { columns: columns, rows: rows };

    } else {
        return { columns: columns, rows: [] };
    }
}